import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // Sentry integration (env-var-gated)
    if (window.Sentry) {
      window.Sentry.captureException(error, { extra: info });
    } else {
      // eslint-disable-next-line no-console
      console.error("[ErrorBoundary]", error, info);
    }
  }
  render() {
    if (this.state.hasError) {
      return (
        <section className="notfound">
          <div className="notfound__inner">
            <div className="notfound__code">Oops</div>
            <h1 className="notfound__title">Something went wrong</h1>
            <p className="notfound__body">
              We hit an unexpected error. Try refreshing the page — if it
              persists, please reach out at customerservice@ril.com.
            </p>
            <div className="notfound__actions">
              <a href="/" className="btn btn--red">
                Back to Home
              </a>
            </div>
          </div>
        </section>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
